<template>
  <v-container
    tag="section"
    class="pa-7"
  >
    <h3>Organization Settings</h3>
    <span class="org-settings-detail">Note: Changes to these settings will affect all users in the organization</span>
    <template v-if="resolved">
      <div
        v-if="hasOutdoorSensors"
        class="org-setting mt-7"
      >
        <toggle
          :value="settings.smartAlerts"
          @toggle="updateOrgSetting('smartAlerts')"
        />
        <div>
          <h6>Smart Alerts</h6>
          <span>
            Reduce alerts caused by weather and loud activity outside of your property.<br>
            Outdoor sensors will only trigger a noise alert if noise is also detected by an indoor sensor.
          </span>
        </div>
      </div>
      <v-divider
        v-if="crowdControlEligible"
        class="my-6"
      />
      <div
        v-if="crowdControlEligible"
        class="org-setting"
      >
        <toggle
          :value="settings.crowdControl"
          @toggle="updateOrgSetting('crowdControl')"
        />
        <div>
          <div id="crowd-control">
            <h6>CrowdControl Alerts</h6>
          </div>
          <span>Get alerted when occupancy is on the rise at your property.</span>
        </div>
      </div>
    </template>
    <div
      v-else
      class="mt-7"
    >
      <v-skeleton-loader type="list-item-avatar@2" />
    </div>
  </v-container>
</template>

<script>
  import Toggle from '@/components/base/Toggle.vue'
  import { mapGetters } from 'vuex'
  import { OCCUPANCY, SMART_ALERTS_DISABLED, SMART_ALERT } from '../../helpers/feature-constants'
  import axios from 'axios'
  export default {
    name: 'OrgSettings',
    components: { Toggle },
    data: function () {
      return {
        hasOutdoorSensors: false,
        crowdControlEligible: false,
        resolved: false,
        settings: {
          crowdControl: false,
          smartAlerts: false,
        },
      }
    },
    computed: {
      ...mapGetters({
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        enabledFlags: 'Organizations/enabledFlags',
        canAdminOrg: 'Permissions/canAdminOrg',
      }),
      settingNames () {
        return {
          smartAlerts: SMART_ALERTS_DISABLED,
          crowdControl: OCCUPANCY,
        }
      },
    },
    watch: {
      async currentSelectedOrg (newOrg) {
        if (newOrg.id && this.canAdminOrg(newOrg.id)) {
          await this.$store.dispatch('Organizations/fetchOrgFlags', { orgId: newOrg.id })
          await this.getSmartAlertEligibility()
          await this.getCrowdControlEligibility()
        } else this.$router.push('/')
      },
    },
    async mounted () {
      await this.getSmartAlertEligibility()
      await this.getCrowdControlEligibility()
      this.resolved = true
      this.setOrgSettings()
    },
    methods: {
      setOrgSettings () {
        this.settings.smartAlerts = !(this.enabledFlags.includes(SMART_ALERTS_DISABLED))
        this.settings.crowdControl = this.enabledFlags.includes(OCCUPANCY)
      },
      updateOrgSetting (settingName) {
        const payload = { name: this.settingNames[settingName], optIn: !this.settings[settingName], orgId: this.currentSelectedOrg.id }
        this.$store.dispatch('Organizations/toggleFlagForOrg', payload)
      },
      async getSmartAlertEligibility () {
        return axios.get(`${this.$store.state.baseURL}/eligibility/org/${this.currentSelectedOrg.id}/feature/${SMART_ALERT}`)
          .then((res) => {
            this.hasOutdoorSensors = res.data.data.isEligible
          })
      },
      async getCrowdControlEligibility () {
        return axios.get(`${this.$store.state.baseURL}/eligibility/org/${this.currentSelectedOrg.id}/feature/${OCCUPANCY}`)
          .then((res) => {
            this.crowdControlEligible = res.data.data.isEligible
          })
      },
    },

  }
</script>

<style lang="scss">
#crowd-control {
    display: flex;
    flex-direction:row;
    justify-content: flex-start;
    align-items: center;
    & > h6 {
        margin-right: 9px;
    }
}
.org-setting {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    & > .toggle {
        margin-top: 10px;
        align-self: flex-start;
    }
}
.org-settings-detail {
    font-family: Lato;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.5px;
    text-align: left;
    color: #929292;
}
</style>
